import last from 'lodash/last';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import { objectToPromoEventTransformer, selectPromotion, viewPromotion } from '../../utils/analytics';

import styles from './ProductMenu.module.scss';

const GA_BANNER_CREATIVE_TAG = 'productsMenu_banner';

export default function ProductListBanner({ slug, banners, categories, category, isSecondLevelPage }) {
  const [bannerShown, setBannerShown] = useState();

  const router = useRouter();

  function onInView() {
    const promo = objectToPromoEventTransformer(bannerShown?.name, bannerShown?.image, GA_BANNER_CREATIVE_TAG);
    viewPromotion(promo);
  }

  function onClick() {
    const promo = objectToPromoEventTransformer(bannerShown?.name, bannerShown?.image, GA_BANNER_CREATIVE_TAG);
    const redirectUrl = bannerShown?.link;
    selectPromotion(promo);

    if (!redirectUrl) return;
    const url = new URL(redirectUrl);
    const urlFullPath = last(url.toString().split(url.hostname));
    router.push(urlFullPath);
  }

  function getBannerCategory() {
    if (!banners.length) return;
    if (isSecondLevelPage) {
      const childCategoryBanner = banners.find(b => b.page === category.slug);
      return childCategoryBanner;
    }
    const parentCategory = categories.find(_category => _category.slugAscii === slug[0]);
    const parentCategoryBanner = banners.find(b => b.page === parentCategory.slug);
    return parentCategoryBanner;
  }

  useEffect(() => {
    const bannerToShow = getBannerCategory();
    setBannerShown(bannerToShow);
  }, [slug]);

  useEffect(() => {
    if (!bannerShown) return;
    onInView();
  }, [bannerShown]);

  if (slug[0] !== 'offers' && bannerShown && bannerShown.image !== '' && bannerShown.image !== undefined) {
    return (
      <Link href={bannerShown.link || '#'}>
        <a className={styles.bannerLink} onClick={onClick}>
          <img className={styles.bannerImage} src={bannerShown.image} alt={bannerShown.alt} />
        </a>
      </Link>
    );
  }
  return null;
}
